<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NY4FLD/media/FC-9781398454361.jpg?1684514755172" alt="This image is the cover for the book Love-'LIFE' Meditations"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Love-'LIFE' Meditations
      </h1>
      <p class="bookDescription body article font2">
        <p>THIS BOOK IS FOR ANYONE WHO BELIEVES IN TURNING THE BASE METAL OF SELF INTO GOLD. WHO CHOOSES A LIFE FULL OF SELF-FULFILLED PROMISES!<br/>This book will become your companion and guide, as it steers you on a magnificent homecoming journey through these pages, just as many mentees have done before you on this Rainbow Path Meditation Series journey. Carol Watson has been guiding groups since 2005 and has over one hundred and eighty scripts and growing. Thirty-five will be shared on these pages.<br/>You’ll love these spiritual stories that are deeply meditative, as you connect with your inner child, your own gorgeous inner male and female, higher self and Great Spirit. Kirsty, a regular member of one of our circles, assures ‘What’s not to love!’<br/>You will be guided, as you read, to help stitch the fabric of a new life pattern for yourself—one full of self-acceptance, reflection, deep peace, the forgiveness of self and others and how you can repair and heal all the parts of you, once neglected. You’ll make friends with your true self and the beautiful wise ones you will meet along this real homecoming journey; beings such as the Protector, Archangel Michael, St Margaret of Scotland. You’ll befriend your Animal Guides and find wisdom from the tree magic you experience, as well as the elemental beings and medicinal herbs.<br/>Colour and healing reconnect you to the golden threads of you that begin to emerge as you go. Base metal is turned into gold as you travel. This book incorporates life coaching and NLP tools, along with spiritual techniques and affirmations to bring you to a new place, a new you. A brighter, lighter, bigger, better YOU. You’ll stretch in ways you never knew possible, find solace in a quieter mind you will learn how to control, and enjoy a happier heart and soul.<br/>ABUNDANCE AND JOY AWAIT YOU. SHALL WE?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carol Watson
      </h2>
      
      <p class="authorDescription body article">Carol Watson founded Rainbow Path Meditation Series, in 2004. She has developed more than 200 guided meditation scripts to aid in healing, finding balance, bringing in peace, joy and wellness to her mentees. Carol facilitates online classes in Edinburgh, Scotland, and in-person. She is an accredited UK clinical hypnotherapist, life coach and NLP facilitator. She moved from a successful career of 22 years in print media into a holistic vocation which began with meditation and energy healing work and developed MA=RaY Light and S.I.R, Past Life Regression, adding complementary therapies such as reflexology, massage and sound medicine.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?006ee1b9